export const challengeDtoFields = [{
        name: "order",
        title: "Order",
        render: (record) => record.challenge.order
    }, {
        name: "name",
        title: "Name",
        render: (record) => record.challenge.name
    }, {
        name: "difficulty",
        title: "Difficulty",
        render: (record) => record.challenge.difficulty
    }, {
        name: "runtimeMs",
        title: "Runtime (ms)",
        render: (record) => record.challenge.runtimeMs
    }, {
        name: "memoryMb",
        title: "Memory (MiB)",
        render: (record) => record.challenge.memoryMb
    }, {
        name: "section",
        title: "Section",
        render: (record) => record.sectionName
    }, {
        name: "active",
        title: "Active",
        render: (record) => `<i class="material-icons">${record.challenge.active === 1 ? "check" : "close"}</i>`
    }];
